import { useTable } from "react-table";
import { useMemo } from "react";
import {
  convertToTilteCase,
  defaultDateDisplay,
  formatCurrency,
  defaultDateOnlyDisplay,
} from "../../../helpers";
import { useSelector } from "react-redux";
import { pathConstants } from "../../../routes/pathContants";
import { Link } from "react-router-dom";

const useGeneralLedgerTable = ({ banks, handleFetchbanks }) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const columns = useMemo(
    () =>
      [
        {
          Header: "Trx Ref",
          accessor: "id",
          Cell: ({ cell: { value }, row }) => (
            <span>
              <Link
                style={{ fontSize: "12px" }}
                className="purple--text"
                to={pathConstants.ACCOUNTING_CHART_ACCOUNT_TRANSACTION_DETAILS({
                  id: value,
                })}
              >
                <span>{value}</span>
              </Link>
              <span className="d-block">
                {defaultDateDisplay(row?.original?.created_at)}
              </span>
            </span>
          ),
        },
        {
          Header: "Journal Ref",
          accessor: "journal_line_item",
          Cell: ({ cell: { value }, row }) =>
            value?.journal_entry?.reference ? (
              <Link
                style={{ fontSize: "12px" }}
                className="purple--text"
                to={pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                  reference: value?.journal_entry?.reference,
                })}
              >
                <span>{value?.journal_entry?.reference}</span>
              </Link>
            ) : (
              "N/A"
            ),
        },
        {
          Header: "Description",
          accessor: "description",
          Cell: ({ cell: { value } }) =>
            value ? convertToTilteCase(value) : "N/A",
        },
        {
          Header: "Opening Amount",
          accessor: "opening_running_balance",
          Cell: ({ cell: { value } }) => (
            <span>
              {formatCurrency({
                value: Math.abs(value),
                currencyCode: currency_code,
              })}{" "}
              {value > 0 ? " Dr" : value < 0 ? " Cr" : ""}
            </span>
          ),
        },
        {
          Header: "Debit Amount",
          accessor: "debit_amount",
          Cell: ({ cell: { value } }) => (
            <span className={value <= 0 && "gray--text"}>
              {" "}
              {formatCurrency({
                value: Math.abs(value),
                currencyCode: currency_code,
              })}
            </span>
          ),
        },
        {
          Header: "Credit Amount",
          accessor: "credit_amount",
          Cell: ({ cell: { value } }) => (
            <span className={value <= 0 && "gray--text"}>
              {" "}
              {formatCurrency({
                value: Math.abs(value),
                currencyCode: currency_code,
              })}
            </span>
          ),
        },
        {
          Header: "Running Balance",
          accessor: "closing_running_balance",
          Cell: ({ cell: { value } }) => (
            <span>
              {formatCurrency({
                value: Math.abs(value),
                currencyCode: currency_code,
              })}{" "}
              {value > 0 ? " Dr" : value < 0 ? " Cr" : ""}
            </span>
          ),
        },
        {
          Header: "Trx Date",
          accessor: "transaction_date",
          Cell: ({ cell: { value } }) =>
            value ? defaultDateOnlyDisplay(value) : "N/A",
        },
        {
          Header: "Store",
          accessor: "store",
          Cell: ({ cell: { value } }) =>
            value ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    background: "#F2EDFE",
                    padding: "6px",
                    borderRadius: "8px",
                    fontSize: "10px",
                    alignItems: "center",
                  }}
                  className="gray--text font-bold"
                >
                  {value?.name}
                </span>
              </div>
            ) : (
              "N/A"
            ),
        },
      ].filter(Boolean),
    [handleFetchbanks],
  );

  const instance = useTable({ columns, data: banks });
  return {
    instance,
    banks,
    handleFetchbanks,
  };
};

export default useGeneralLedgerTable;
